module.exports = __webpack_public_path__ + "img/cityApply.3a239c0a.png";